import LegalPage from "@/components/LegalPage";

const DEFAULT_BODY = (
  <>
    <p className="text-oc-textSecondary"><em>OfferteExpert — Webtron BV</em></p>

    <h2>1. Partijen</h2>
    <p>Deze voorwaarden zijn van toepassing tussen Webtron BV, A. Rodenbachwijk 12, 9792 Waregem, BTW BE0793944703 (hierna "OfferteExpert") en de gebruiker van het platform.</p>

    <h2>2. Beschrijving van de dienst</h2>
    <p>OfferteExpert biedt een onafhankelijke offerte-analyse <strong>uitsluitend voor particulieren (B2C)</strong>. Bedrijven, zelfstandigen, vzw's en andere zakelijke entiteiten zijn niet toegelaten als klant. Onze marktreferenties zijn afgestemd op consumentenprijzen en niet op zakelijke tarieven, aankoopcondities of B2B-relaties. Het rapport heeft een indicatief karakter en vervangt geen professioneel of juridisch advies.</p>

    <h2>3. Prijs en betaling</h2>
    <p>De prijs bedraagt €4,99 per analyse, BTW inbegrepen. Betalingen verlopen via MultiSafepay. Betalingen zijn niet terugvorderbaar nadat de analyse succesvol is uitgevoerd, behalve in geval van technische fout van OfferteExpert.</p>

    <h2>4. Aansprakelijkheid</h2>
    <p>De analyse is gebaseerd op actuele markttarieven en publiek beschikbare prijsdata. OfferteExpert doet geen uitspraken over de juistheid van individuele offertes en is niet aansprakelijk voor beslissingen die de gebruiker neemt op basis van het rapport. De totale aansprakelijkheid van OfferteExpert is beperkt tot het bedrag van de betaalde analyse.</p>

    <h2>5. Intellectueel eigendom</h2>
    <p>Het rapport, de software en alle visuele elementen behoren tot het intellectueel eigendom van Webtron BV. Reverse engineering, geautomatiseerd schrappen of commerciële herdistributie is verboden.</p>

    <h2>6. Privacy</h2>
    <p>Zie ons <a href="/privacy-policy">Privacybeleid</a> voor de verwerking van persoonsgegevens.</p>

    <h2>7. Gegevensbewaring</h2>
    <p>Documenten en analyseresultaten worden 30 dagen bewaard en daarna automatisch verwijderd.</p>

    <h2>8. Toepasselijk recht</h2>
    <p>Het Belgisch recht is van toepassing. Geschillen worden voorgelegd aan de bevoegde rechtbanken van Gent, afdeling Kortrijk.</p>

    <h2>9. Contact</h2>
    <p>Voor klachten of vragen: <a href="mailto:info@offerteexpert.be">info@offerteexpert.be</a>.</p>
  </>
);

export default function Voorwaarden() {
  return <LegalPage slug="voorwaarden" defaultTitle="Algemene voorwaarden" defaultBody={DEFAULT_BODY} />;
}
